import React, { useState, useEffect, useRef } from 'react';
import {Button, Hidden, IconButton, Typography} from '@mui/material';
import {AddBox} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import MaterialTable from 'material-table';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import {isAdmin, TableCount, TablePage} from "../../../../../config/Permissions";
import {getDataTableLocalization} from "../../../../../config/Translate";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {tableIcons} from "../../../../../config/design/TableIcons";
import {defaultVariables} from "../../../../../config";
import {useIsSmall} from "../../../../../config/hooks/useWindowDimensions";
import {useTranslation} from "react-i18next";
import {currencySymbol, price, showTableDate} from "../../../../../config/values";
import AddProfitButton from "./AddProfitButton";
import ProfitStocks from "./ProfitStocks";

const Profits = ({ classes }) => {
    const isSmall = useIsSmall();
    const { t } = useTranslation();

    const [columns] = useState([

        {
            title: t("titleProfit"),
            field: "title",
        },
        {
            title: t('profit_amount'),
            editable: 'never',
            field: 'amount',
            render: rowData => (
                <Typography>
                    {price(rowData.amount)} {currencySymbol}
                </Typography>
            )
        },
        {
            title: t('stocks_count'),
            editable: 'never',
            field: 'stocks_count',
        },
        {
            title: t('stock_type'),
            editable: 'never',
            field: 'stock_type',
            render: rowData => (
                <Typography>
                    {t(rowData.stock_type)}
                </Typography>
            )
        },
        {
            title: t('profit_type'),
            editable: 'never',
            field: 'type',
            render: rowData => (
                <Typography>
                    {t(rowData.type)}
                </Typography>
            )
        },
        {
            title: t('viewStocks'),
            editable: 'never',
            field: 'type',
            render: rowData => (
                <ProfitStocks profit={rowData}/>
            )
        },
        {
            title: t('created_at'),
            editable: 'never',
            field: 'created_at',
            render: rowData => (
                <Typography className={classes.dateTable}>
                    {showTableDate(rowData.created_at)}
                </Typography>
            )
        },
    ]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const tableRef = useRef(null);
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () => {
        tableRef.current && tableRef.current.onQueryChange();
    };
    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            {
                loading ? "Loading" :
                    <div className="main-table">
                        <MaterialTable
                            tableRef={tableRef}
                            icons={tableIcons}
                            title={
                                !!isAdmin() ?
                                <AddProfitButton reload={() => loadData()}/>
                                    :
                                    " "
                            }
                            localization={getDataTableLocalization()}
                            columns={columns}
                            data={query =>
                                new Promise((resolve, reject) => {
                                    axios.get(`${defaultVariables.url}/profits/quickView?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`, {
                                        headers: {
                                            Accept: 'application/json',
                                            Authorization: `Bearer ${localStorage.getItem('ACT')}`
                                        }
                                    }).then(response => {
                                        const data = response.data.data.map(row => ({
                                            id: row.id,
                                            title: row.title,
                                            amount: row.amount,
                                            stock_type: row.stock_type,
                                            type: row.type,
                                            stocks_count: row.stocks_count,
                                            created_at: row.created_at,
                                            ownerships: row.ownerships,
                                        }));
                                        resolve({
                                            data: data,
                                            page: response.data.current_page - 1,
                                            totalCount: response.data.total
                                        });
                                    }).catch(error => console.log(error.response));
                                })
                            }
                            options={{
                                pageSize: TablePage,
                                pageSizeOptions: TableCount,
                                defaultExpanded: false,
                                draggable: false,
                            }}
                        />
                    </div>
            }
        </>
    );
};
export default withStyles(Styles)(Profits);
